import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import Birthdays from "../components/structureComponent/birthdaysComponent";

export default function BirthdaysPage() {
    return (
        <Layout>
            <Header/>
            <Birthdays/>
            <Footer/>
        </Layout>
    );
}